import React, { useState } from 'react';
import classNames from 'classnames';
import styles from './assets/program-array-fields.module.scss';
import FormTarget from './PBTargetForm';
import { change } from 'redux-form';
import { useDispatch } from 'react-redux';

const RenderFieldArray = (props: any) => {
    const {
        fields,
        remove,
        setIsManualChangeValue,
        isManualChangeValue,
        setTargetManualChangeValue,
        targetManualChangeValue,
        programBookId,
    } = props;
    return (
        <div className={classNames(styles.ul, styles.targetWrap)}>
            {fields.map((member: any, index: number, array: any) => (
                <RenderSubFields
                    key={`i-${index}`}
                    member={member}
                    remove={remove}
                    fields={array}
                    isLast={index + 1 === fields.length}
                    isNotFirst={!!index}
                    index={index}
                    setIsManualChangeValue={setIsManualChangeValue}
                    isManualChangeValue={isManualChangeValue}
                    setTargetManualChangeValue={setTargetManualChangeValue}
                    targetManualChangeValue={targetManualChangeValue}
                    programBookId={programBookId}
                />
            ))}
        </div>
    );
};
type Props = {
    member: any;
    index: number;
    fields: any;
    isLast: boolean;
    remove: boolean;
    isNotFirst: boolean;
    setIsManualChangeValue: (it: boolean) => void;
    isManualChangeValue: any;
    setTargetManualChangeValue: (it: string) => void;
    targetManualChangeValue: any;
    programBookId?: any;
};

const RenderSubFields: React.FunctionComponent<Props> = ({
    member,
    remove,
    index,
    fields,
    isLast,
    isNotFirst,
    setIsManualChangeValue,
    isManualChangeValue,
    setTargetManualChangeValue,
    targetManualChangeValue,
    programBookId,
}) => {
    const row = fields.get(index);

    const dispatch = useDispatch();
    const [changeSt, setChanged] = useState(false);

    const hideRow = () => {
        setIsManualChangeValue(true);
        setTargetManualChangeValue(row.id);
        setTimeout(() => {
            dispatch(change('program-book', `${member}.isSkip`, 1));
            setChanged(!changeSt);
        }, 200);
    };
    const showRow = () => {
        setIsManualChangeValue(true);
        setTargetManualChangeValue(row.id);
        setTimeout(() => {
            dispatch(change('program-book', `${member}.isSkip`, 0));
            setChanged(!changeSt);
        }, 200);
    };

    return (
        <div key={index} className={classNames(styles.wrappedFieldsTarget, row.isHidden == 1 ? styles.hidden : '')}>
            <FormTarget
                remove={remove}
                fields={fields}
                memberD={member}
                row={row}
                isMastered={row.isMastered}
                isPhased={row.isPhased}
                showOption={row.type == 3 || row.type?.value == 3}
                //showPrompt={row?.programTargetPrompts?.length}
                showPrompt={false}
                hideRow={hideRow}
                showRow={showRow}
                setIsManualChangeValue={setIsManualChangeValue}
                isManualChangeValue={isManualChangeValue}
                setTargetManualChangeValue={setTargetManualChangeValue}
                targetManualChangeValue={targetManualChangeValue}
                programBookId={programBookId}
            />
        </div>
    );
};
export default RenderFieldArray;
